import { Case } from '../../shared/model/case';
import { StateService } from './state.service';
import { Observable } from 'rxjs';

export class CaseStateService extends StateService<Case> {
  public sendCase(obj: Case): void {
    this.sendModel(obj);
  }

  public getCase(): Observable<Case> {
    return this.getModel();
  }
}
